

































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SponsorSetList'

  vue:
    props: ['sponsorSet', 'options']
    store: ['member', 'marketplace']

    data: ->
      onlyPrimary: true
      logoLoadingErrors: {}

    computed:
      max: -> @options?.max || 24
      secretBrandDomains: -> Object.keys(@marketplace?.secret_brands || {})
      primarySponsorSetDomains: -> @ctxEventSet(@event).primary_sponsor_set_domains || []

      _sponsorSet: ->
        set = [...(@sponsorSet || [])]
        set.sort((a, b) =>
          if (a.domain isnt b.domain)
            return -1 if @isMeSponsoring(a)
            return 1 if @isMeSponsoring(b)
          0
        )

      visibleSponsorSet: ->
        return @_sponsorSet unless @primarySponsorSetDomains.length

        primary = []
        others = []

        for sponsor in @_sponsorSet
          if sponsor.domain in @primarySponsorSetDomains
            primary.push sponsor
          else if !@onlyPrimary
            others.push sponsor

        list = [...primary, ...others].slice(0, @max)
        list.sort((sponsorA, sponsorB) =>
          aIndex = @primarySponsorSetDomains.indexOf sponsorA.domain
          bIndex = @primarySponsorSetDomains.indexOf sponsorB.domain

          a = aIndex + 1
          b = bIndex + 1
          sameSignal = (aIndex < 0 and bIndex < 0) || (aIndex >= 0 and bIndex >= 0)
          if sameSignal then a - b else b - a
        )
        list
      
      displayShowMore: ->
        return false unless @primarySponsorSetDomains.length
        return false if @primarySponsorSetDomains.length is @sponsorSet.length
        return false if @primarySponsorSetDomains.length >= @max
        true

    methods:
      isMeSponsoring: (sponsor) ->
        { formatDomain } = @$options.filters
        isSameCampaignDomain = formatDomain(sponsor.domain) is formatDomain(@options?.campaign?.brand_info?.domain)
        isSameSponsorDomain = formatDomain(sponsor.domain) is formatDomain(@member?.sponsor?.domain)
        isSameCampaignDomain || isSameSponsorDomain

      isSecretBrand: (sponsor) ->
        { formatDomain } = @$options.filters
        formatDomain(sponsor.domain) in @secretBrandDomains

      setError: (sponsor, error) ->
        @logoLoadingErrors[sponsor.name] = error

export default VueOptions.vue settings
